import { trackPromise } from "react-promise-tracker";
import { axiosBridge } from "../network/AxiosBridge";
import { API_URL, StatusCodes } from '../network/Configurations';

const addRoleType = (request: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.post(API_URL.ADD_ROLE_TYPE, request)
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const updateRoleType = (request: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.put(API_URL.UPDATE_ROLE_TYPE, request)
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const deleteRoleType = (params: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.delete(API_URL.DELETE_ROLE_TYPE, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const getRoleTypeById = (params: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.get(API_URL.GET_ROLE_TYPE, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const getRoleTypeList = (): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.get(API_URL.GET_ROLE_TYPE_LIST)
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

export const RoleTypeService = {
    addRoleType,
    updateRoleType,
    deleteRoleType,
    getRoleTypeById,
    getRoleTypeList
}